import { useLocation } from "react-router-dom";
import { useContext } from 'react'
import { useAppSelector } from 'reducers/hooks'
import { MILESTONE_URL } from "config";
import { AuthenticationContext } from 'components/Authentication/AuthenticationProvider'
import { selectIsAuthenticated } from 'reducers/userSlice'
import "./header.scss";
import "./headersectionblock";

const Header = () => {
    const authenticationContext = useContext(AuthenticationContext)
    const isAuthenticated = useAppSelector(selectIsAuthenticated)
    const location = useLocation();
    const setCssClasses = (url, page) => {
        let baseCssClasses = "header-section-block__navigation-menu header-section-block__navigation-menu--level1"
        if (url === page || (page === "/" && url.startsWith("/project"))) {
            return baseCssClasses + " header-section-block__navigation-menu--level1-parent";
        }

        return baseCssClasses;
    }

    return (
        <div id="HeaderSection" className="header-section-sticky">
            <div className="row g-0 no-gutters">
                <div className="header-section-block col-12">
                    <div className="header-section-block__container header-section-block__container--desktop top-margin-for-old-pages">
                        <div className="header-section-block__logos">
                            <div id="xsd__e2e-milestone-logo"
                                 className="header-section-block__milestone-logo"
                                 onClick={() => window.location.href = MILESTONE_URL()}
                                 role="button"
                            ></div>
                            <div className='header-section-block__logo-divider'></div>
                            <div>
                                <a id="xsd__e2e-xsd-logo" href="/" className="header-section-block__xsd-logo">
                                    XProtect Solution Designer
                                </a>
                            </div>
                        </div>
                        <nav id="MainMenu" className="header-section-block__navigation">
                            <div className="header-section-block__navigation-menus">
                                <div className="d-inline-block d-xl-none hidden-lg header-section-block__navigation-menus-button-close-container">
                                    <div className="header-section-block__navigation-menus-button-close ms-icon">
                                        <svg viewBox="0 0 128 128" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <path fill="unset" d="M63.646 54.433L99.079 19 109 28.921 73.567 64.354 108.29 99.08 98.371 109 63.645 74.276 29.63 108.29l-9.921-9.92 34.015-34.017L19 29.63l9.921-9.921z" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="header-section-block__navigation-menu-container">
                                    <div className={setCssClasses(location.pathname, "/")}>
                                        <a id="xsd__e2e-projects-menu-link" href="/" className="header-section-block__navigation-menu-label">
                                            Projects
                                        </a>
                                    </div>
                                </div>
                                <div className="header-section-block__navigation-menu-container">
                                    <div className={setCssClasses(location.pathname, "/release-notes/")}>
                                        <a id="xsd__e2e-release-notes-menu-link" href="/release-notes/" className="header-section-block__navigation-menu-label">
                                            Release Notes
                                        </a>
                                    </div>
                                </div>
                                <div className="header-section-block__navigation-menu-container">
                                    <div className={setCssClasses(location.pathname, "/disclaimer/")}>
                                        <a id="xsd__e2e-disclaimer-menu-link" href="/disclaimer/" className="header-section-block__navigation-menu-label">
                                            Disclaimer
                                        </a>
                                    </div>
                                </div>
                                <div className="header-section-block__burger-links">
                                    <div className="d-block d-md-none header-section-block__login-button">
                                        <button
                                            id="xsd__e2e-small-devices-sign-in-button"
                                            type="button"
                                            className="button-tile-block msds-btn msds-btn--secondary msds-btn--sm"
                                            onClick={authenticationContext.handleLoginButtonClick}>
                                            {isAuthenticated ? 'Log out' : 'Log In'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </nav>
                        <div className="header-section-block__links">
                            <button
                                id="xsd__e2e-desktop-sign-in-button"
                                type="button"
                                className="button-tile-block msds-btn msds-btn--secondary msds-btn--sm"
                                onClick={authenticationContext.handleLoginButtonClick}>
                                {isAuthenticated ? 'Log out' : 'Log In'}
                            </button>
                            <button
                                id="xsd__e2e-burger-menu-link"
                                className="header-section-block__links-burger-menu-link"
                                type="button">
                                <div className="ms-icon">
                                    <svg viewBox="0 0 132 132" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 30h120v8H4zm0 30h120v8H4zm0 30h120v8H4z" fillRule="evenodd" />
                                    </svg>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;